"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MediaViewer = _interopRequireDefault(require("./MediaViewer"));
var _MessageInfo = _interopRequireDefault(require("./MessageInfo"));
const methods = {
  props: {},
  displayNick() {
    let props = this.props;
    let suffix = props.message.nick ? ':' : '';
    return props.message.nick + suffix;
  },
  userMode(user) {
    let props = this.props;
    return props.ml.buffer.userMode(user);
  },
  userModePrefix(user) {
    let props = this.props;
    return props.ml.buffer.userModePrefix(user);
  }
};
var _default = exports.default = {
  inject: {
    components: {
      default: {
        MessageInfo: _MessageInfo.default,
        MediaViewer: _MediaViewer.default
      }
    }
  },
  props: {
    ml: Object,
    message: Object,
    idx: Number,
    m: {
      default: function m() {
        // vue uses this function to generate the prop. `this`==null Return our own function
        return function n() {
          // Give our methods some props context before its function is called.
          // This is only safe because the function on the methods object is called on
          // the same js tick
          methods.props = this;
          return methods;
        };
      }
    }
  }
};